import { Observable, of } from 'rxjs';
import { CustomerServerAPI } from '../../../../namespaces/';
import { ICustomerServer } from '../../../../java/interfaces/';

export function customerServerAdaptivaCdnStatus(serverObject: ICustomerServer): Observable<string> {
  let _status: string;
  if (CustomerServerAPI.getFailedAtTask(serverObject)) {
    _status = CustomerServerAPI.getFailedAtTask(serverObject);
  } else if (CustomerServerAPI.getFailureMessage(serverObject)) {
    _status = CustomerServerAPI.getFailureMessage(serverObject);
  } else {
    _status = CustomerServerAPI.toCDNStatusString(serverObject.adaptivaCdnStatus);
  }
  return of(_status);
}
